<template>
  <div class="h-full 300 overflow-auto container pb-24 pr-8 dark:bg-[#1c1c1d] bg-white p-3">
    <!-- Recommended Follows -->
    <div class="border-b border-gray-300 py-4 mt-4">
      <p class="text-md text-black dark:text-white font-bold mb-4">Who to follow</p>
      <transition-group name="list" tag="div" class="flex flex-col gap-4">
        <div
          v-if="Object.keys(slicedRecommendedFollows).length > 0"
          v-for="profile in slicedRecommendedFollows"
          :key="profile.ulid"
          @click="navigateToProfile(profile.username)"
          class="flex items-center gap-2 w-full text-sm cursor-pointer select-none mr-4"
        >
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center">
              <div class="size-8 rounded-full">
                <UserAvatar :avatar="profile.avatar" />
              </div>
              <div class="flex-col ml-2 md:max-w-[4rem] lg:max-w-[6rem]">
                <p class="font-semibold text-black dark:text-white pr-1 truncate md:max-w-[4rem] lg:max-w-[6rem]">
                  {{ profile.name }}
                </p>
                <p class="text-gray-600 text-xs truncate md:max-w-[4rem] lg:max-w-[6rem]">
                  @{{ profile.username }}
                </p>
              </div>
            </div>
            <button
              v-if="profile.username !== authStore.currentUser.username"
              @click.stop="followUser(profile.username, profile.ProfileEngagement?.isFollowing, profile.ulid)"
              class="cursor-pointer select-none"
            >
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_11977_172904)">
                  <path d="M1.5 15C1.5 7.54416 7.54416 1.5 15 1.5C22.4558 1.5 28.5 7.54416 28.5 15C28.5 22.4558 22.4558 28.5 15 28.5C7.54416 28.5 1.5 22.4558 1.5 15Z" :fill="profile?.ProfileEngagement?.isFollowing ? 'var(--primary-color)' : 'black'" shape-rendering="crispEdges"/>
                  <path d="M22.9998 15.5001C22.9998 15.6327 22.9472 15.7598 22.8534 15.8536C22.7596 15.9474 22.6324 16.0001 22.4998 16.0001H21.4998V17.0001C21.4998 17.1327 21.4472 17.2598 21.3534 17.3536C21.2596 17.4474 21.1324 17.5001 20.9998 17.5001C20.8672 17.5001 20.7401 17.4474 20.6463 17.3536C20.5525 17.2598 20.4998 17.1327 20.4998 17.0001V16.0001H19.4998C19.3672 16.0001 19.2401 15.9474 19.1463 15.8536C19.0525 15.7598 18.9998 15.6327 18.9998 15.5001C18.9998 15.3674 19.0525 15.2403 19.1463 15.1465C19.2401 15.0527 19.3672 15.0001 19.4998 15.0001H20.4998V14.0001C20.4998 13.8674 20.5525 13.7403 20.6463 13.6465C20.7401 13.5527 20.8672 13.5001 20.9998 13.5001C21.1324 13.5001 21.2596 13.5527 21.3534 13.6465C21.4472 13.7403 21.4998 13.8674 21.4998 14.0001V15.0001H22.4998C22.6324 15.0001 22.7596 15.0527 22.8534 15.1465C22.9472 15.2403 22.9998 15.3674 22.9998 15.5001ZM19.383 19.1782C19.4683 19.2798 19.5098 19.4112 19.4983 19.5434C19.4869 19.6756 19.4233 19.7978 19.3217 19.8832C19.2201 19.9685 19.0887 20.0101 18.9565 19.9986C18.8243 19.9871 18.7021 19.9235 18.6167 19.8219C17.3592 18.3244 15.6305 17.5001 13.7498 17.5001C11.8692 17.5001 10.1405 18.3244 8.88296 19.8219C8.7976 19.9235 8.67539 19.9869 8.54324 19.9983C8.41109 20.0098 8.2798 19.9682 8.17828 19.8829C8.07675 19.7975 8.01329 19.6753 8.00186 19.5431C7.99043 19.411 8.03197 19.2797 8.11734 19.1782C9.05109 18.0669 10.2123 17.2776 11.503 16.8551C10.7192 16.3669 10.1157 15.6367 9.7838 14.775C9.45193 13.9133 9.40974 12.9669 9.66362 12.0791C9.91749 11.1913 10.4536 10.4103 11.1909 9.85429C11.9281 9.2983 12.8264 8.99756 13.7498 8.99756C14.6732 8.99756 15.5715 9.2983 16.3088 9.85429C17.0461 10.4103 17.5822 11.1913 17.8361 12.0791C18.0899 12.9669 18.0477 13.9133 17.7159 14.775C17.384 15.6367 16.7805 16.3669 15.9967 16.8551C17.2873 17.2776 18.4486 18.0669 19.383 19.1782ZM13.7498 16.5001C14.3926 16.5001 15.021 16.3094 15.5554 15.9523C16.0899 15.5952 16.5065 15.0876 16.7524 14.4938C16.9984 13.8999 17.0628 13.2465 16.9374 12.616C16.812 11.9856 16.5025 11.4065 16.0479 10.952C15.5934 10.4974 15.0143 10.1879 14.3839 10.0625C13.7534 9.9371 13.1 10.0015 12.5061 10.2474C11.9123 10.4934 11.4047 10.91 11.0476 11.4445C10.6904 11.9789 10.4998 12.6073 10.4998 13.2501C10.5008 14.1117 10.8436 14.9378 11.4528 15.5471C12.0621 16.1563 12.8882 16.4991 13.7498 16.5001Z" fill="#FAFAFA"/>
                </g>
                <defs>
                  <filter id="filter0_d_11977_172904" x="0.5" y="0.5" width="31" height="31" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dx="1" dy="1"/>
                    <feGaussianBlur stdDeviation="1"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11977_172904"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11977_172904" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </button>
          </div>
        </div>
        <div v-else>
          <p class="text-gray-500 text-sm">
            No recommended accounts for you
          </p>
        </div>
        <p
          v-if="
            Object.keys(recommendedFollows).length > recommendedShown ||
            Object.keys(recommendedFollows).length == recommendedShown
          "
          class="text-blue-500 font-bold text-sm cursor-pointer select-none"
          @click="showMore('recommendedUsers')"
        >
          Show More
        </p>
      </transition-group>
    </div>

    <!-- Trending Hashtags -->
    <div class="border-b border-gray-300 py-4">
      <p class="text-md text-black dark:text-white font-bold mb-4">Trending Topics</p>
      <div
        v-if="trendingHashtags.length > 0"
        v-for="hashtag in trendingHashtags.slice(
          0,
          trendingHashtagsShown
        )"
        :key="hashtag"
        @click="goToHashtagSearch(hashtag.hashtag)"
        class="py-1 cursor-pointer select-none"
      >
        <div>
          <p class="font-bold text-black dark:text-white">#{{ hashtag.hashtag }}</p>
          <p class="text-gray-500">{{ hashtag.count }} Posts</p>
        </div>
      </div>
      <div v-else>
        <p class="text-gray-500 text-sm">No recommended topics for you</p>
      </div>
      <p
        v-if="
          trendingHashtags.length > trendingHashtagsShown ||
          trendingHashtags == trendingHashtagsShown
        "
        class="text-blue-500 font-bold text-sm cursor-pointer select-none"
        @click="showMore('trendingHashtags')"
      >
        Show More
      </p>
    </div>
  </div>
</template>

<script setup>

import { usePostStore } from "@/stores/post";
import { useUserStore } from "@/stores/users";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import UserAvatar from "../components/UserAvatar.vue";
import {
  getCurrentInstance,
  ref,
  watch,
  onMounted,
  computed,
  onUnmounted,
  onBeforeUnmount,
} from "vue";
import { toastController } from "@ionic/vue";
import { useRouter } from "vue-router";

const postStore = usePostStore();
const usersStore = useUserStore();
const authStore = useAuthStore();
const router = useRouter();
const trendingHashtags = ref([]);
const recommendedShown = ref(5);
const trendingHashtagsShown = ref(5);

const slicedRecommendedFollows = computed(() => {
  return recommendedFollowIds.value
    .map((id) => usersStore?.users[id])
    .filter((user) => user && user.username !== authStore.currentUser.username && !user.ProfileEngagement?.isFollowing)
    .slice(0, recommendedShown.value);
});

const showMore = (type) => {
  if (type === "recommendedUsers") {
    recommendedShown.value += 5;
  }
  if (type === "trendingHashtags") {
    trendingHashtagsShown.value += 5;
  }
};

let numberOfFollows = 0; 

const followUser = async (username, following = false, ulid) => {
  if (following) {
    try {
      await usersStore.unfollowUser(username);
    } catch (error) {
      console.error("Error unfollowing user:", error);
    }
    return;
  }

  try {
    let res = await usersStore.followUser(username, ulid);

    if (res.data.success === true) {
      showToast("User followed successfully", "success");
      numberOfFollows++;
      if (numberOfFollows > 10) {
        usersStore.fetchNewRecommendedUsers = true;
      }
      
    }
  } catch (error) {
    console.error("Error following user:", error);
    showToast("Error following user", "danger");
  }
};

const showToast = async (message, color) => {
  const toast = await toastController.create({
    message: message,
    duration: 1500,
    color: color,
  });
  await toast.present();
};

const recommendedFollowIds = ref([]);

const recommendedFollows = computed(() => {
  //fetch trending users
  return recommendedFollowIds.value
    .map((id) => usersStore?.users[id])
    .filter((user) => user && user.username !== authStore.currentUser.username && !user.ProfileEngagement?.isFollowing);

});


const fetchRecommendedFollows = async () => {
  try {
    // Fetch trending users
    const trendingUserIds = await usersStore.fetchTrendingUsers(true);

    // Update recommended follows with users not being followed
    recommendedFollowIds.value = trendingUserIds;
  } catch (error) {
    console.error("Error fetching recommended follows:", error);
  }
};

const fetchTrendingHashtags = async () => {
  try {
    trendingHashtags.value = await postStore.fetchTrendingHashtags();
  } catch (error) {
    console.error("Error fetching trending hashtags:", error);
  }
};

const navigateToProfile = (username) => {
  const encodedUsername = encodeURIComponent(username);

  router.push(`/${encodedUsername}`);
};

const goToHashtagSearch = (hashtag) => {
  router.push(`/hashtag/${hashtag}`);
};

const isMdScreen = ref(false); // For screens that are at least md size

const checkScreenSize = () => {
  isMdScreen.value = window.matchMedia('(min-width: 768px)').matches;
};

watch(isMdScreen, (newVal, oldVal) => {
  // Check if the screen has transitioned from a smaller size to md size
  if (newVal === true && oldVal === false) {
    if (recommendedFollows.value.length === 0) {
      fetchRecommendedFollows();
    }
    if (trendingHashtags.value.length === 0) {
      fetchTrendingHashtags();
    }
  }
});

onMounted(() => {
  checkScreenSize(); // Check screen size on mount
  window.addEventListener('resize', checkScreenSize); // Attach resize listener

  if (isMdScreen.value) {
    fetchRecommendedFollows();
    fetchTrendingHashtags();
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkScreenSize); // Remove resize listener
});

onUnmounted(() => {
  numberOfFollows = 0;
});

</script>

<style scoped>

.list-enter-active, .list-leave-active {
  transition: all 0.5s ease;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.slide-trending-enter-active {
  transition: transform 0.2s ease;
}

.slide-trending-leave-active {
  transition: transform 0.2s ease;
}

.slide-trending-enter-from {
  transform: translateY(-100%);
}

.slide-trending-leave-to {
  transform: translateY(-100%);
}

.bg-primary {
  background-color: var(--primary-color);
}

.bg-secondary {
  background-color: var(--secondary-color);
}

.container::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge, and Firefox */
.container {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tx-primary {
  fill: var(--primary-color);
}
</style>
